module.exports = __webpack_public_path__ + "media/images/vglist-logo-ddfb2e956638ad34729d687defc109aa.svg";